import axios from 'axios';
import properties from '../../properties';
import { Payload } from '../../helper-utils/apiPayloadHelper';
import { CohortMembersCountResponse } from '../Cohort/Summary';

export const getSummary = async (
  payload: Payload,
  member_unique_id_list: string[],
) => {
  return await axios.post(
    properties.aiqBaseUrl +
      properties.benchmarkBaseURL +
      properties.getBenchmarkSummary,
    { ...payload, member_unique_id_list },
  );
};
export const getCategories = async (
  payload: Payload,
  member_unique_id_list: string[],
) => {
  return await axios.post(
    properties.aiqBaseUrl +
      properties.benchmarkBaseURL +
      properties.getCategories,
    { ...payload, member_unique_id_list },
  );
};
export const getCategoryDetails = async (
  payload: Payload,
  category: string,
  pageNumber: Number,
  member_unique_id_list: string[],
  pageSize?: Number,
  sortField?: string,
  sortOrder?: Number,
) => {
  return await axios.post(
    properties.aiqBaseUrl +
      properties.benchmarkBaseURL +
      properties.getCategoryDetails,
    {
      ...payload,
      category,
      pageNumber,
      pageSize,
      sortField,
      sortOrder,
      member_unique_id_list,
    },
  );
};

export const getCategoryDetailsSummary = async (
  payload: Payload,
  category: string,
): Promise<CohortMembersCountResponse> => {
  const response = await axios.post(
    properties.aiqBaseUrl +
      properties.benchmarkBaseURL +
      properties.getBenchmarkDetailsSummary,
    {
      ...payload,
      category,
    },
  );
  return response.data.data;
};
